import { bindActionCreators } from '@reduxjs/toolkit'
import { actions as addressActions } from 'feature/addresses/redux/AddressSlice'
import { companyAddressActions } from 'feature/addresses/redux/CompanyAddressSlice'
import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store/types'

import { AddressSliceKey } from './useAddressState'

// Хук для получения экшенов адреса по ключу слайса
export const useAddressSliceActions = (key: AddressSliceKey = 'default') => {
  const dispatch: AppDispatch = useDispatch<AppDispatch>()
  const actions = key === 'company' ? companyAddressActions : addressActions

  return useMemo(
    () => bindActionCreators(actions, dispatch),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, key],
  )
}
